import PopupInformation from "shared/components/popups/PopupInformation.js";

const PopupTermsAndConditions = ({ trigger }) => {
  return (
    <PopupInformation
      trigger={trigger}
      title={
        <>
          <i className="bi bi-file-earmark-text me-1"></i>Terms And Conditions
        </>
      }
      className="popup-lg"
      content={
        <div className="text-white">
          <table className="table table-striped table-hover w-100 bg-black">
            <thead>
              <tr>
                <th>Topic</th>
                <th>Terms</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Premium Activation</td>
                <td>Premium is activated automatically after Stripe confirms a successful payment.</td>
              </tr>

              <tr>
                <td>Username</td>
                <td>
                  During checkout you must provide the username that will receive Premium access. Premium is granted to
                  the submitted username, regardless of who pays.
                </td>
              </tr>

              <tr>
                <td>Gift Purchases</td>
                <td>
                  You may purchase a subscription for another user's account by entering their username during checkout.
                </td>
              </tr>

              <tr>
                <td>Automatic Renewal</td>
                <td>
                  Subscription plans renew automatically at the end of each billing period unless cancelled before the
                  renewal date.
                </td>
              </tr>

              <tr>
                <td>Cancellation</td>
                <td>
                  You may cancel your subscription at any time. Cancellation prevents future renewals but does not
                  affect Premium access already paid for during the current billing period.
                </td>
              </tr>

              <tr>
                <td>Refunds</td>
                <td>
                  Payments are generally non-refundable except where required by applicable law or where otherwise
                  determined at our sole discretion.
                </td>
              </tr>

              <tr>
                <td>Account Sharing</td>
                <td>
                  A subscription is intended for one username only. Premium benefits may not be transferred between
                  usernames after activation.
                </td>
              </tr>

              <tr>
                <td>Service Changes</td>
                <td>
                  Premium features may evolve over time. Features may be added, improved, modified or removed in order
                  to maintain and improve the service.
                </td>
              </tr>

              <tr>
                <td>Availability</td>
                <td>
                  While we strive for continuous availability, uninterrupted access cannot be guaranteed due to
                  maintenance, technical issues or circumstances beyond our control.
                </td>
              </tr>

              <tr>
                <td>Abuse</td>
                <td>
                  We reserve the right to suspend or terminate Premium access in cases of fraud, abuse, chargebacks or
                  violations of our Terms of Service.
                </td>
              </tr>
            </tbody>
          </table>

          <p className="mt-3 text-white">
            <strong>By completing your purchase</strong>, you agree to these subscription terms and acknowledge that
            recurring subscriptions will renew automatically until cancelled.
          </p>

          <p className="text-white mb-0">
            These subscription terms supplement the application's Terms of Service and Privacy Policy, where applicable.
          </p>
        </div>
      }
    />
  );
};

export default PopupTermsAndConditions;
